import UIModel from "../model/UIModel"
import UIView from "@baseUI/views/UIView";
import UIController from "@baseUI/controllers/UIController";

export default class UIBaseApplication {
    constructor() {

        this.uiModel = new UIModel()
        this.uiView = new UIView()
        this.uiController = new UIController(this.uiModel, this.uiView)
    }

}